<template>
  <div>
    <div
      class="head-tips"
      @click="handleUpdateVisaCard"
      v-if="currentDpCard && currentDpCard.status === 8"
    >
      <img src="~img/icon-warning-triangle-red.svg" alt="warning" /><span
        ><b>{{ $t('card-suspended') }}.</b>&nbsp;{{ $t('card-suspended-desc') }}</span
      ><img src="~img/icon-right.svg" alt="update you card details" />
    </div>
    <div class="membership">
      <h1 class="mbs-title">{{ $t('mbs-my-account') }}</h1>

      <div class="mbs-user">
        <div class="user-info-left">
          <left-account
            :userData="userData"
            @handleHeadEdit="handleHeadEdit"
            @handleSelect="handleSelect"
          >
          </left-account>
        </div>

        <div class="mbs-info-right">
          <router-view :minHeight="minHeight"></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftAccount from '@/components/LeftAccount';
  import store from '@/store';
  import { mapState } from 'vuex';

  export default {
    components: {
      LeftAccount,
    },

    props: {
      minHeight: {
        type: String,
        default: '0px',
      },
    },

    watch: {
      '$route.query': {
        handler(newval) {
          if (newval?.switchSuccess) {
            // 切换卡成功后跳转到当前页面，并且展示成功的弹窗
            this.$messageModal.show({
              i18nNeed: true,
              image: true,
              title: 'mbs-switch-success-title',
              desc: '',
              confirmBtn: 'ok',
              justHide: true,
            });
          }
        },
        deep: true,
      },
    },

    computed: {
      ...mapState(['currentDpCard']),
    },

    mounted() {
      // if (this.$route.params.fromSideMenu) {
      //   console.log(111);
      // }
    },
    data() {
      return {
        userData: {},
      };
    },

    methods: {
      // 左侧列表头部编辑按钮事件触发
      handleHeadEdit() {
        console.log('点击头部修改');
      },

      // 左侧列表select按钮事件触发
      handleSelect(data) {
        if (data.key === 'membership') this.$router.push('/account/membership');
        if (data.key === 'favourites') this.$router.push('/account/favourites');
        if (data.key === 'places') this.$router.push('/account/places');
        if (data.key === 'email') this.$router.push('/account/email');
        if (data.key === 'changekey') this.$router.push('/account/changeKey');
        if (data.key === 'history') this.$router.push('/account/history');
        if (data.key === 'mfa') this.$router.push('/account/mfa');
        if (data.key === 'service') this.$router.push('/account/service');
        if (data.key === 'privacysettings') this.$router.push('/account/privacysettings');
        if (data.key === 'contact') this.$router.push('/account/contact');
        if (data.key === 'mytrips') this.$router.push('/account/mytrips');
        if (data.key === 'notify') this.$router.push('/account/notify');
        if (data.key === 'deleteaccount') this.$router.push('/account/deleteaccount');
        if (data.key === 'logout') {
          this.$messageModal.show({
            i18nNeed: true,
            closeIcon: true,
            desc: 'mbs-ques1',
            confirmBtn: 'btn-confirm',
            cancelBtn: 'btn-cancel',
            justHide: true,
            successCallback: this.handleLogOut,
          });
        }
      },

      handleLogOut() {
        store.dispatch('loginModule/logout');
        // this.$router.push('/');
      },

      handleUpdateVisaCard() {
        this.$router.push({ path: '/updatevisacard' });
      },
    },
  };
</script>

<style lang="scss" scoped>
@use './index';
</style>
